import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import actions from '@src/redux/actions';
import {
  calculateReferralStats,
  getReferralCharacterReward,
} from '@src/services/referral';
import { getReferral } from '@src/apis/referral';
import { formatNumber } from '@src/utils/number';
import { StyledReferralStats } from './index.style';
import StatCard from './StatCard';

const ReferralStats = ({ setMaxRewardCharacter, setRedeemedCharacters }) => {
  const dispatch = useDispatch();
  const { t, i18n } = useTranslation();
  const { language } = i18n;
  const referralConfig = useSelector((state) => state.referralConfig);
  const { charsPerPoint } = referralConfig || {};
  const { user } = useSelector((state) => state.auth);
  const { referral } = user;
  const {
    earnedPoints = 0,
    spentPoints = 0,
    refereeFirstPaidOrderCount = 0,
  } = referral || {};
  const initPoints = earnedPoints - spentPoints;

  const stats = calculateReferralStats(user?.referral, charsPerPoint);

  useEffect(() => {
    const fetchReferral = async () => {
      const response = await getReferral();

      const {
        referralSuccessCount,
        redeemedCharsThisMonth,
        earnedPoints: earnedPointsResponse = 0,
        spentPoints: spentPointsResponse = 0,
      } = response.result;
      const currentMaxRewardCharacter = getReferralCharacterReward({
        points: initPoints,
        redeemedCharsThisMonth,
        referralConfig,
      });
      setRedeemedCharacters(redeemedCharsThisMonth);
      setMaxRewardCharacter(currentMaxRewardCharacter);
      dispatch(
        actions.auth.updateReferralStats({
          earnedPoints: earnedPointsResponse,
          spentPoints: spentPointsResponse,
          referralSuccessCount,
        }),
      );
    };
    fetchReferral();
  }, [initPoints, referralConfig]);

  return (
    <StyledReferralStats>
      <div className="referral-stats-container">
        <div className="referral-stats">
          <StatCard
            value={formatNumber(stats.totalUsers, language)}
            label={t('referralStatsTotalUsers')}
          />
          <StatCard
            value={formatNumber(refereeFirstPaidOrderCount, language)}
            label={t('firstBuyPackageReferralReward')}
          />
          <StatCard
            value={formatNumber(stats.claimedChars, language)}
            label={t('referralStatsClaimedChars')}
          />
        </div>
      </div>
    </StyledReferralStats>
  );
};

export default ReferralStats;
